import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Qs from "qs";
import JwtService from "@/common/jwt.service";
import { API_URL } from "@/common/config";
// import { SET_AUTH, CLEAR_AUTH } from "@/store/auth.module";

// var APP_SECTION = "default";
var _store = null;
// var _router = null;

const url_config = {
  login: "auth/access",
  logout: "auth/logout",
  refresh: "auth/refresh"
};

const isLogin = url => {
  return url.endsWith(url_config.login);
};

// const isRefresh = url => {
// return url.endsWith(url_config.refresh);
// };

// var isRefreshing = false;

const setHeaderToken = (config, section) => {
  config.headers["Authorization"] = `Bearer ${JwtService.getTokens(
    section,
    "access_token"
  )}`;

  return config;
};

// var _suspended = [];

/**
 * Interceptors
 */
// Add a request interceptor
axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent

    const section = _store.state.config.section;
    // if (isRefreshing && !isRefresh(config.url)) {
    //   config._retry = true;
    //   _suspended.push(config);

    //   return {
    //     ...config,
    //     cancelToken: new CancelToken(cancel =>
    //       cancel("Cancel repeated request")
    //     )
    //   };
    // }

    if (!isLogin(config.url)) {
      // console.log("Set Token");
      config = setHeaderToken(config, section);
    }

    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
/* axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error

    const originalRequest = error.config;
    const section = _store.state.config.section;
    const prefix = section === "default" ? "" : section;

    if ([401, 403].indexOf(error.response.status) !== -1) {
      if (isRefresh(originalRequest.url)) {
        _store.dispatch(CLEAR_AUTH, section);
        _router.push({ name: `${prefix}/login` });

        return Promise.reject(error);
      }

      if (!originalRequest._retry) {
        originalRequest._retry = true;
        isRefreshing = true;

        return axios
          .post(`${prefix}/${url_config.refresh}`, {
            refresh_token: JwtService.getTokens(section, "refresh_token")
          })
          .then(res => {
            isRefreshing = false;
            if ([200, 201].indexOf(res.status) !== -1) {
              _store.dispatch(SET_AUTH, {
                section: section,
                tokens: res.data,
                isLogin: true
              });

              axios.all([..._suspended]);
              // .then(axios.spread(function (acct, perms) {
              //   // Both requests are now complete
              // }));

              return Vue.axios(originalRequest);
            }
          });
      }
    }

    return Promise.reject(error);
  }
);*/

/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
  init(store) {
    // APP_SECTION = section;

    _store = store;
    // _router = router;

    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_URL;
  },

  /**
   * Set the default HTTP request headers
   */
  setHeader(section = "") {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${JwtService.getTokens(section, "access_token")}`;
  },

  query(resource, params) {
    const options = {
      params: {
        ...params
      },
      paramsSerializer: _params => {
        return Qs.stringify(_params, { arrayFormat: "brackets" });
      }
    };

    return Vue.axios.get(resource, options).catch(error => {
      // console.log(error);
      throw new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  get(resource, slug = "") {
    const _slug = slug ? `/${slug}` : "";
    return Vue.axios.get(`${resource}${_slug}`);
    // .catch(error => {
    //   console.log(error);
    //   throw new Error(`ApiService ${error}`);
    // });
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, params) {
    return Vue.axios.post(`${resource}`, params);
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, slug, params) {
    const _slug = slug ? `/${slug}` : "";
    return Vue.axios.put(`${resource}${_slug}`, params);
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete(resource) {
    return Vue.axios.delete(resource);
  }
};

export default ApiService;
